(function () {
    'use strict';

    angular.module("imApp").factory("finishPohScanService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 194,
                    parameters: parms || {}
                });
            },
            listStockBatchLasts: function (parms) {
                return $ihttp.post({
                    method: 2469,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
